"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AddLifeEvent;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const UserContext_1 = require("../contexts/UserContext");
const react_native_paper_1 = require("react-native-paper");
const Button_1 = __importDefault(require("../components/Button"));
const Loading_1 = __importDefault(require("../components/Loading"));
const react_i18next_1 = require("react-i18next");
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const SearchableDropdown_1 = __importDefault(require("../components/SearchableDropdown"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const react_native_paper_dates_1 = require("react-native-paper-dates");
const FileUpload_1 = __importDefault(require("../components/FileUpload"));
const Benefits_1 = __importDefault(require("../api/Benefits"));
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const ThemeContext_1 = require("../ThemeContext");
const FadeInView_1 = __importDefault(require("../components/FadeInView"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function AddLifeEventHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.DuoTone.FileMedical, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { "aria-label": props['aria-label'], style: { color: THEME.Text, fontWeight: '500', fontSize: size != 'sm' ? 18 : 16, marginLeft: 8 }, children: props.text }), !!props.subText && (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, marginLeft: 8 }, children: props.subText })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: 'borderless', onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
function AddLifeEventForm(props) {
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const STYLES = (0, Theme_1.useGlobalStyles)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('done');
    const [eventDate, setEventDate] = react_1.default.useState(null);
    const [lifeEventReq, setLifeEventReq] = react_1.default.useState({
        employeeId: props.employeeId ?? '',
        eventDate: '',
        eventType: '',
        gcpFileName: '',
        firstName: '',
        lastName: '',
        otherDetails: '',
    });
    const [uploadedFileName, setUploadedFileName] = react_1.default.useState('');
    const eventTypeOptions = [
        {
            label: t('myBenefits:labels.marriage'),
            value: 'Marriage'
        },
        {
            label: t('myBenefits:labels.divorce'),
            value: 'Divorce'
        },
        {
            label: t('myBenefits:labels.birth'),
            value: 'Birth'
        },
        {
            label: t('myBenefits:labels.dependentDeath'),
            value: 'DependentDeath'
        },
        {
            label: t('myBenefits:labels.spouseDeath'),
            value: 'SpouseDeath'
        },
        {
            label: t('myBenefits:labels.coverageLoss'),
            value: 'CoverageLoss'
        },
        {
            label: t('myBenefits:labels.eligibilityGain'),
            value: 'EligibilityGain'
        },
        {
            label: t('myBenefits:labels.residenceChange'),
            value: 'ResidenceChange'
        }
    ];
    const uploadTypes = {
        Marriage: {
            filePrefix: 'MarriageCertificate',
            filename: 'MarriageCertificate',
            prompt: t('myBenefits:text.marriageCertPrompt')
        },
        Divorce: {
            filePrefix: 'DivorceDecree',
            filename: 'DivorceDecree',
            prompt: t('myBenefits:text.divorceDecreePrompt')
        },
        Birth: {
            filePrefix: 'BirthCertificate',
            filename: 'BirthCertificate',
            prompt: t('myBenefits:text.birthCertPrompt')
        },
        DeathCertificate: {
            filePrefix: 'DeathCertificate',
            filename: 'DeathCertificate',
            prompt: t('myBenefits:text.deathCertPrompt')
        },
        CoverageLoss: {
            filePrefix: 'CoverageLoss',
            filename: 'CoverageLoss',
            prompt: t('myBenefits:text.coverageLossPrompt')
        },
        EligibilityGain: {
            filePrefix: 'EligibilityGain',
            filename: 'EligibilityGain',
            prompt: t('myBenefits:text.eligibilityGainPrompt')
        },
        ResidenceChange: {
            filePrefix: 'ResidenceChange',
            filename: 'ResidenceChange',
            prompt: t('myBenefits:text.residenceChangePrompt')
        },
        OtherLifeEvent: {
            filePrefix: 'OtherLifeEvent',
            filename: 'OtherLifeEvent',
            prompt: t('myBenefits:text.otherLifeEventPrompt')
        },
    };
    const [uploadType, setUploadType] = react_1.default.useState(uploadTypes['OtherLifeEvent']);
    // Helper to parse MM/DD/YYYY string to Date object
    const parseDateString = (dateStr) => {
        if (!dateStr || typeof dateStr !== 'string' || dateStr.length !== 10)
            return null;
        const [month, day, year] = dateStr.split('/').map(Number);
        if (!month || !day || !year)
            return null;
        const date = new Date(year, month - 1, day);
        return isNaN(date.getTime()) ? null : date;
    };
    const refresh = react_1.default.useCallback(() => {
        if (props.employeeId && props.lifeEventId) {
            promise.current?.cancel();
            setStatus('loading');
            promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => MyProfile_1.default.getPersonalInfo(token, props.employeeId))).then((data) => {
                react_native_1.DeviceEventEmitter.emit('event.lifeEventEELoaded', { name: `${data.firstName} ${data.lastName}`.replace(/\s+/g, ' ') });
                return userContext.getToken().then((token) => Benefits_1.default.getPendingLifeEvent(token, props?.employeeId, props.lifeEventId));
            }).then((data) => {
                data.gcpFileName = ''; // Don't prefill file name since we don't want to show the previously uploaded file as already uploaded
                setLifeEventReq(data);
                setEventDate(parseDateString(data.eventDate));
                switch (data?.eventType) {
                    case 'Marriage':
                        setUploadType(uploadTypes['Marriage']);
                        break;
                    case 'Divorce':
                        setUploadType(uploadTypes['Divorce']);
                        break;
                    case 'Birth':
                        setUploadType(uploadTypes['Birth']);
                        break;
                    case 'DependentDeath':
                        setUploadType(uploadTypes['DeathCertificate']);
                        break;
                    case 'SpouseDeath':
                        setUploadType(uploadTypes['DeathCertificate']);
                        break;
                    case 'CoverageLoss':
                        setUploadType(uploadTypes['CoverageLoss']);
                        break;
                    case 'EligibilityGain':
                        setUploadType(uploadTypes['EligibilityGain']);
                        break;
                    case 'ResidenceChange':
                        setUploadType(uploadTypes['ResidenceChange']);
                        break;
                    default:
                        setUploadType(uploadTypes['OtherLifeEvent']);
                        break;
                }
                setStatus('done');
            })
                .catch((e) => {
                setStatus(e == 204 ? 'done' : 'loadError');
            });
        }
        else if (props.employeeId && !props.lifeEventId) {
            promise.current?.cancel();
            setStatus('loading');
            promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => MyProfile_1.default.getPersonalInfo(token, props.employeeId))).then((data) => {
                react_native_1.DeviceEventEmitter.emit('event.lifeEventEELoaded', { name: `${data.firstName} ${data.lastName}`.replace(/\s+/g, ' ') });
                setStatus('done');
            }).catch((e) => {
                setStatus('loadError');
            });
        }
        else if (!props.employeeId && props.lifeEventId) {
            promise.current?.cancel();
            setStatus('loading');
            promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => Benefits_1.default.getPendingLifeEvent(token, props?.employeeId, props.lifeEventId))).then((data) => {
                data.gcpFileName = ''; // Don't prefill file name since we don't want to show the previously uploaded file as already uploaded
                setLifeEventReq(data);
                setEventDate(parseDateString(data.eventDate));
                switch (data?.eventType) {
                    case 'Marriage':
                        setUploadType(uploadTypes['Marriage']);
                        break;
                    case 'Divorce':
                        setUploadType(uploadTypes['Divorce']);
                        break;
                    case 'Birth':
                        setUploadType(uploadTypes['Birth']);
                        break;
                    case 'DependentDeath':
                        setUploadType(uploadTypes['DeathCertificate']);
                        break;
                    case 'SpouseDeath':
                        setUploadType(uploadTypes['DeathCertificate']);
                        break;
                    case 'CoverageLoss':
                        setUploadType(uploadTypes['CoverageLoss']);
                        break;
                    case 'EligibilityGain':
                        setUploadType(uploadTypes['EligibilityGain']);
                        break;
                    case 'ResidenceChange':
                        setUploadType(uploadTypes['ResidenceChange']);
                        break;
                    default:
                        setUploadType(uploadTypes['OtherLifeEvent']);
                        break;
                }
                setStatus('done');
            }).catch((e) => {
                setStatus(e == 204 ? 'done' : 'loadError');
            });
        }
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
            react_native_1.DeviceEventEmitter.removeAllListeners('event.lifeEventEELoaded');
        };
    }, [refresh]);
    const onFileUploadError = react_1.default.useCallback((error) => {
        setUploadedFileName('');
        setLifeEventReqField('gcpFileName', '');
        let message = t('company:messages.uploadError');
        if (error == 400)
            message = t('company:messages.uploadErrorType');
        react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'error', message });
    }, [uploadedFileName, lifeEventReq]);
    const handleSubmit = react_1.default.useCallback(() => {
        setStatus('loading');
        if (!formHasErrors()) {
            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                'feature': 'Submit Life Event',
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId
            });
            promise.current?.cancel();
            promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => Benefits_1.default.addLifeEvent(token, lifeEventReq)))
                .then(() => {
                react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'success', message: props.employeeId ? t('myBenefits:messages.addLifeEventSuccessMary') : t('myBenefits:messages.addLifeEventSuccess') });
                react_native_1.DeviceEventEmitter.emit('event.lifeEventUpdate');
                props.onSaved();
            })
                .catch((e) => {
                react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'error', message: t('myBenefits:messages.addLifeEventFailed') });
                setStatus('error');
            });
        }
        else {
            react_native_1.DeviceEventEmitter.emit('event.showSnackbar', { type: 'error', message: t('employees:messages.checkFields') });
            setStatus('done');
        }
    }, [lifeEventReq, uploadedFileName]);
    const close = () => {
        promise.current?.cancel();
        props.onCancel();
    };
    const setLifeEventReqField = (fieldName, value) => {
        props.onIsChanged();
        setLifeEventReq({
            ...lifeEventReq,
            [fieldName]: value
        });
    };
    // Check if an input field has a valid value
    const hasErrors = (field, value) => {
        switch (field) {
            case 'date':
                return value.length != 10;
            case 'text':
                return !value || /^\s*$/.test(value) ? true : false;
        }
    };
    const formHasErrors = () => {
        let error = hasErrors('text', lifeEventReq.eventType)
            || hasErrors('date', lifeEventReq.eventDate)
            || (lifeEventReq.eventType == 'Other' ? hasErrors('text', lifeEventReq.otherDetails) : false)
            || ((lifeEventReq.eventType == 'CoverageLoss' || lifeEventReq.eventType == 'EligibilityGain') ? hasErrors('text', lifeEventReq.firstName) : false)
            || ((lifeEventReq.eventType == 'CoverageLoss' || lifeEventReq.eventType == 'EligibilityGain') ? hasErrors('text', lifeEventReq.lastName) : false)
            || (lifeEventReq.eventType != 'Other' && lifeEventReq.eventType != 'ResidenceChange' && !uploadedFileName);
        return error;
    };
    return ((status == 'done' && ((0, jsx_runtime_1.jsxs)(FadeInView_1.default, { style: { flex: 1 }, children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flex: 1, backgroundColor: THEME.WarningLightest, flexDirection: 'row', alignItems: 'center', padding: 12, borderRadius: 4, marginBottom: 20 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { color: THEME.Warning, icon: Theme_1.ICONS.Regular.CircleExclamation, size: 18, style: { marginRight: 12 } }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { fontSize: 11, color: THEME.TextMuted, flex: 1 }, children: t('myBenefits:messages.reportLifeEventWarning') })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_dates_1.DatePickerInput, { activeOutlineColor: THEME.Primary, animationType: 'fade', "aria-label": t('myBenefits:labels.lifeEventDate'), dense: true, hasError: hasErrors('date', lifeEventReq.eventDate), hideValidationErrors: true, inputMode: 'start', label: t('myBenefits:labels.lifeEventDate') + ' *', locale: 'en', mode: 'outlined', onChange: (d) => {
                        let dateStr = `${(d?.getUTCMonth() + 1).toString().padStart(2, '0')}/${d?.getUTCDate().toString().padStart(2, '0')}/${d?.getUTCFullYear()}`;
                        setLifeEventReqField('eventDate', dateStr);
                        setEventDate(d);
                        props?.onIsChanged();
                    }, onChangeText: (value) => {
                        let dateStr = value.replace(/[^0-9/]/g, '');
                        setLifeEventReqField('eventDate', dateStr);
                    }, onValidationError: () => null, presentationStyle: 'overFullScreen', saveLabel: t('common:buttons.confirm'), startYear: 1900, value: eventDate }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(SearchableDropdown_1.default, { error: hasErrors('text', lifeEventReq.eventType), list: eventTypeOptions, label: `${t('myBenefits:labels.lifeEventType')} *`, mode: 'outlined', titleNumberOfLines: 2, setValue: (value) => {
                        setLifeEventReqField('eventType', value);
                        switch (value) {
                            case 'Marriage':
                                setUploadType(uploadTypes['Marriage']);
                                break;
                            case 'Divorce':
                                setUploadType(uploadTypes['Divorce']);
                                break;
                            case 'Birth':
                                setUploadType(uploadTypes['Birth']);
                                break;
                            case 'DependentDeath':
                                setUploadType(uploadTypes['DeathCertificate']);
                                break;
                            case 'SpouseDeath':
                                setUploadType(uploadTypes['DeathCertificate']);
                                break;
                            case 'CoverageLoss':
                                setUploadType(uploadTypes['CoverageLoss']);
                                break;
                            case 'EligibilityGain':
                                setUploadType(uploadTypes['EligibilityGain']);
                                break;
                            case 'ResidenceChange':
                                setUploadType(uploadTypes['ResidenceChange']);
                                break;
                            default:
                                setUploadType(uploadTypes['OtherLifeEvent']);
                                break;
                        }
                    }, value: lifeEventReq.eventType, inputProps: { dense: true } }) }), (lifeEventReq.eventType == 'CoverageLoss' || lifeEventReq.eventType == 'EligibilityGain') &&
                (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('login:labels.firstName'), activeOutlineColor: THEME.Primary, dense: true, error: hasErrors('text', lifeEventReq.firstName), label: `${t('login:labels.firstName')} *`, mode: 'outlined', onChangeText: (value) => setLifeEventReqField('firstName', value), style: STYLES.input, value: lifeEventReq.firstName }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: size != 'sm' ? 1 : null, marginBottom: 12 }, children: (0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('login:labels.lastName'), activeOutlineColor: THEME.Primary, dense: true, error: hasErrors('text', lifeEventReq.lastName), label: `${t('login:labels.lastName')} *`, mode: 'outlined', onChangeText: (value) => setLifeEventReqField('lastName', value), style: STYLES.input, value: lifeEventReq.lastName }) })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_paper_1.TextInput, { "aria-label": t('myBenefits:labels.otherDetails'), activeOutlineColor: THEME.Primary, dense: true, error: lifeEventReq.eventType == 'Other' ? hasErrors('text', lifeEventReq.otherDetails) : false, label: lifeEventReq.eventType == 'Other' ? `${t('myBenefits:labels.otherDetails')} *` : t('myBenefits:labels.otherDetails'), mode: 'outlined', onChangeText: (value) => setLifeEventReqField('otherDetails', value), style: STYLES.input, value: lifeEventReq.otherDetails, multiline: true, numberOfLines: 5, maxLength: 250 }), (0, jsx_runtime_1.jsxs)(react_native_1.Text, { style: { marginTop: 6, fontSize: 12, fontStyle: 'italic', color: THEME.Text, opacity: 0.7, textAlign: 'right' }, children: [lifeEventReq.otherDetails.length ?? 0, " / 250"] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginBottom: 12 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { marginBottom: 8, fontSize: 12, fontWeight: '500', color: THEME.Text, opacity: 0.7, textAlign: 'left' }, children: uploadType.prompt }), (0, jsx_runtime_1.jsx)(FileUpload_1.default, { disabled: userContext?.isImpersonated || !!uploadedFileName || !lifeEventReq.eventType, buttonText: t('common:buttons.upload'), waitingText: t('common:text.pleaseWait'), getUploadUrl: (type, name) => {
                            setUploadedFileName(name);
                            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                                'feature': `Upload Life Event File - ${uploadType.filename}`,
                                'client': userContext?.client?.id,
                                'employee': userContext?.employee?.employeeId
                            });
                            let fileUrl = userContext.getToken().then(token => Benefits_1.default.startUpload(token, uploadType.filePrefix, type, name, props.employeeId).then(response => {
                                setLifeEventReqField('gcpFileName', response.name);
                                return response.url;
                            }));
                            return Promise.resolve(fileUrl);
                        }, onUploaded: () => {
                            userContext.getToken().then(token => Benefits_1.default.listUploads(token, uploadType.filePrefix, props.employeeId).then(d => {
                                d.map((u, i) => ({
                                    name: u.filename ?? `$(${i + 1})`,
                                    date: u.readableDate,
                                    type: u.readableType,
                                    size: u.readableSize
                                }));
                            }));
                        }, onError: onFileUploadError }), !!uploadedFileName &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6 }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Solid.CircleCheck, size: 12, color: THEME.Primary }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { marginLeft: 6, fontSize: 12, color: THEME.Text, textAlign: 'left' }, children: uploadedFileName })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', text: t('common:buttons.cancel'), onPress: () => close() }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: formHasErrors() || userContext?.isImpersonated, text: t('common:buttons.submit'), onPress: () => handleSubmit() }) })] })] }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error' || status == 'loadError', onRetry: status == 'loadError' ? () => refresh() : () => handleSubmit() }));
}
function AddLifeEvent(props) {
    const scrollViewRef = react_1.default.useRef(null);
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const [name, setName] = react_1.default.useState('');
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const [isChanged, setIsChanged] = react_1.default.useState(false);
    const [isConfirming, setIsConfirming] = react_1.default.useState(false);
    const onClose = () => {
        if (isChanged) {
            setIsConfirming(true);
        }
        else {
            props.navigation.goBack();
        }
    };
    react_native_1.DeviceEventEmitter.addListener('event.lifeEventEELoaded', (eventData) => onLifeEventEELoaded(eventData));
    const onLifeEventEELoaded = (result) => {
        setName(result?.name ?? '');
    };
    react_1.default.useEffect(() => {
        return () => {
            react_native_1.DeviceEventEmitter.removeAllListeners('event.lifeEventEELoaded');
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, needsConfirmation: isChanged, onConfirmation: () => setIsConfirming(true), children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 2 }, children: (0, jsx_runtime_1.jsx)(AddLifeEventHeader, { "aria-label": t('common:screenTitles.lifeEvent'), text: t('common:screenTitles.lifeEvent'), subText: name, onClose: onClose }) }), (0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, keyboardShouldPersistTaps: 'handled', ref: scrollViewRef, children: [isConfirming &&
                        (0, jsx_runtime_1.jsxs)(react_native_1.View, { children: [(0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { marginBottom: 12, backgroundColor: THEME.UltraLightGray, borderRadius: 4, flexDirection: 'row' }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { width: 6, borderBottomLeftRadius: 4, borderTopLeftRadius: 4, backgroundColor: THEME.Red } }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { padding: 12, flex: 1 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, fontWeight: '500', paddingVertical: 1 }, children: t('common:text.sure') }), (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontSize: size != 'sm' ? 14 : 12, paddingVertical: 1 }, children: t('common:text.sureDescription') })] })] }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 6, marginBottom: size != 'sm' ? 0 : 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: 'outline', text: t('common:buttons.back'), onPress: () => setIsConfirming(false) }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { text: t('common:buttons.discard'), onPress: () => props.navigation.goBack() }) })] })] }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { display: isConfirming ? 'none' : undefined }, children: (0, jsx_runtime_1.jsx)(AddLifeEventForm, { employeeId: props.route.params?.employeeId ?? '', lifeEventId: props.route.params?.lifeEventId ?? '', onCancel: onClose, onSaved: props.navigation.goBack, navigation: props.navigation, scrollViewRef: scrollViewRef, onIsChanged: () => setIsChanged(true) }) })] })] }));
}
